export const gas = {
  title: 'Földgáz modul',
  subtitle: 'POD-ok, szerződések, kapacitás-lekötés, számlázás és kimutatások.',
  nav: {
    group: 'Földgáz',
    dashboard: 'Áttekintés',
    pods: 'POD-ok',
    contracts: 'Szerződések',
    readings: 'Mérőállások',
    invoices: 'Számlák',
    nominations: 'Nominálások',
    customers: 'Gáz ügyfelek'
  },
  sections: {
    pods: 'Földgáz POD-ok',
    contracts: 'Földgáz szerződések',
    readings: 'Gáz mérőállások',
    invoices: 'Gáz számlák',
    nominations: 'Gáz nominálások'
  },
  customer: {
    isGasCustomer: 'Gáz ügyfél',
    badge: 'Gáz',
    gasCustomersFilter: 'Gáz ügyfelek'
  },
  common: {
    new: 'Új',
    add: 'Hozzáadás',
    save: 'Mentés',
    cancel: 'Mégse',
    delete: 'Törlés',
    edit: 'Szerkesztés',
    refresh: 'Frissítés',
    search: 'Keresés',
    select: 'Válassz',
    upload: 'Feltöltés',
    import: 'Import',
    export: 'Export',
    downloadExample: 'Minta letöltése',
    processing: 'Feldolgozás',
    uploading: 'Feltöltés...',
    loading: 'Betöltés...',
    noData: 'Nincs megjeleníthető adat.',
    selectAll: 'Mindet kijelöl',
    selectedCount: 'kijelölve'
  },
  pod: {
    id: 'POD ID',
    name: 'Név',
    address: 'Cím',
    city: 'Város',
    street: 'Utca',
    postalCode: 'Irányítószám',
    country: 'Ország',
    meterSerialNumber: 'Mérőszám',
    meterType: 'Mérő típus',
    gasQuality: 'Gáz minőség',
    measurementType: 'Mérési típus',
    capacityKw: 'Kapacitás (kW)',
    maxHourlyCapacityM3: 'Max. órai kapacitás (m³/h)',
    status: 'Státusz',
    statuses: {
      active: 'Aktív',
      inactive: 'Inaktív',
      terminated: 'Megszüntetett'
    },
    noPodAvailable: 'Nincs elérhető gáz POD. Előbb vegyél fel POD-okat.',
    errors: {
      podIdRequired: 'POD ID megadása kötelező',
      addressRequired: 'Cím megadása kötelező'
    },
    fields: {
      postalCode: 'Irányítószám',
      city: 'Város',
      street: 'Közterület',
      houseNumber: 'Házszám',
      plotNumber: 'Helyrajzi szám',
      measurementType: 'Mérési típus',
      gasQuality: 'Gázminőség',
      meterSerialNumber: 'Mérő gyári szám',
      meterType: 'Mérő típus',
      placeholder: {
        podId: 'Mérési pont kód',
        name: 'Opcionális'
      }
    }
  },
  contract: {
    number: 'Szerződésszám',
    type: 'Szerződés típusa',
    types: {
      energy: 'Energia (molekula)',
      rhd_variable: 'RHD forgalom-arányos',
      rhd_fixed: 'RHD fix / teljesítmény'
    },
    startDate: 'Kezdő dátum',
    endDate: 'Vége dátum',
    capacityKwh: 'Kapacitás (kWh)',
    capacityM3: 'Kapacitás (m³)',
    maxHourlyCapacityM3: 'Max. órai kapacitás (m³/h)',
    price: 'Ár',
    priceUnit: 'Egység',
    currency: 'Pénznem',
    spread: 'Spread',
    vatRate: 'ÁFA %',
    isFixedPrice: 'Fix ár',
    linkedPods: 'Kapcsolódó POD-ok',
    linkedPodsCount: 'kapcsolódó POD',
    status: 'Státusz',
    statuses: {
      draft: 'Vázlat',
      active: 'Aktív',
      expired: 'Lejárt',
      terminated: 'Felmondott'
    },
    unnamed: 'Névtelen szerződés',
    fields: {
      contractNumber: 'Szerződés száma',
      contractType: 'Szerződés típusa',
      startDate: 'Kezdő dátum',
      endDate: 'Vége dátum',
      capacityKwh: 'Kapacitás (kWh)',
      capacityM3: 'Kapacitás (m³)',
      maxHourlyCapacityM3: 'Max. órai kapacitás (m³/h)',
      price: 'Ár',
      priceUnit: 'Egység',
      currency: 'Pénznem',
      spread: 'Spread',
      vatRate: 'ÁFA %',
      isFixedPrice: 'Fix ár',
      linkedPods: 'Kapcsolódó POD-ok',
      notes: 'Megjegyzés',
      placeholder: {
        contractNumber: 'Pl. GAZ-2026-001',
        price: '0.00',
        priceUnit: 'Ft/kWh vagy Ft/m³'
      }
    },
    errors: {
      contractTypeRequired: 'Szerződés típusa kötelező',
      startDateRequired: 'Kezdő dátum kötelező'
    }
  },
  reading: {
    gasDay: 'Gáznap',
    readingDate: 'Lelolvasás dátuma',
    meterStatus: 'Mérőállás (m³)',
    consumptionM3: 'Fogyasztás (m³)',
    energyKwh: 'Energia (kWh)',
    calorificValue: 'Fűtőérték (MJ/m³)',
    correctionFactor: 'Korrekciós tényező',
    status: 'Státusz',
    statuses: {
      estimated: 'Becsült',
      read: 'Leolvasott',
      corrected: 'Helyesbített'
    },
    source: 'Forrás',
    sources: {
      manual: 'Kézi',
      mscsons: 'MSCONS',
      invoice: 'Számla',
      import: 'Import'
    },
    bulkUpload: 'Tömeges mérőállás feltöltés',
    bulkFormat: 'Formátum: POD_ID;GAS_DAY;METER_STATUS;CONSUMPTION_M3;ENERGY_KWH',
    bulkExample: 'gaz_meroallas_minta.csv',
    bulkMessages: {
      noInput: 'Adj meg legalább egy mérőállást',
      invalidRows: '{{count}} hibás sor található',
      parsedRows: '{{count}} mérőállás feldolgozva',
      noSelectedRows: 'Nincs kiválasztott érvényes mérőállás',
      uploadedRows: '{{count}} mérőállás feltöltve',
      uploadError: 'Hiba a mérőállások feltöltésekor',
      errors: {
        podIdAndGasDayRequired: 'Legalább POD ID és gáznap szükséges',
        unknownPodId: 'Ismeretlen POD ID',
        invalidGasDayFormat: 'Érvénytelen gáznap formátum (YYYY-MM-DD)',
        invalidMeterStatus: 'Érvénytelen mérőállás',
        invalidConsumption: 'Érvénytelen fogyasztás (m³)',
        invalidEnergy: 'Érvénytelen energia (kWh)'
      }
    },
    fields: {
      gasPod: 'Gáz POD',
      gasDay: 'Gáznap',
      readingDate: 'Lelolvasás dátuma',
      meterStatus: 'Mérőállás (m³)',
      consumptionM3: 'Fogyasztás (m³)',
      energyKwh: 'Energia (kWh)',
      calorificValue: 'Fűtőérték (MJ/m³)',
      correctionFactor: 'Korrekciós tényező',
      status: 'Státusz',
      source: 'Forrás',
      note: 'Megjegyzés'
    },
    errors: {
      podRequired: 'Válassz ki egy gáz POD-ot',
      gasDayRequired: 'Gáznap megadása kötelező'
    }
  },
  invoice: {
    period: 'Időszak',
    periodStart: 'Időszak kezdete',
    periodEnd: 'Időszak vége',
    gasDays: 'Gáznapok száma',
    invoiceNumber: 'Számlaszám',
    status: 'Státusz',
    statuses: {
      draft: 'Vázlat',
      issued: 'Kiállítva',
      paid: 'Fizetve',
      cancelled: 'Sztornó'
    },
    lines: 'Számlasorok',
    lineType: 'Típus',
    lineTypes: {
      energy: 'Energia',
      rhd: 'RHD',
      capacity: 'Kapacitás',
      penalty: 'Büntetés',
      fee: 'Díj',
      other: 'Egyéb'
    },
    autoFill: 'Automatikus kitöltés',
    autoFillSuccess: 'számlasor generálva',
    autoFillError: 'Nincs elérhető mérőállás vagy ár az automatikus kitöltéshez',
    noLines: 'Nincs még számlasor. Adj hozzá legalább egyet.',
    totalNet: 'Nettó',
    totalVat: 'ÁFA',
    totalGross: 'Bruttó',
    errors: {
      contractRequired: 'Válassz ki egy érvényes szerződést',
      periodRequired: 'Add meg az időszakot',
      noLines: 'Legalább egy számlasor szükséges'
    },
    fields: {
      contract: 'Szerződés (automatikus kitöltéshez)',
      billingPeriodStart: 'Időszak kezdete',
      billingPeriodEnd: 'Időszak vége',
      gasDays: 'Gáznapok száma',
      invoiceNumber: 'Számlaszám',
      currency: 'Pénznem',
      status: 'Státusz',
      notes: 'Megjegyzés',
      lines: 'Számlasorok',
      lineDescription: 'Megnevezés',
      lineType: 'Típus',
      lineQuantity: 'Mennyiség',
      lineUnit: 'Egység',
      lineUnitPrice: 'Egységár',
      lineVatRate: 'ÁFA %',
      addLine: 'Sor hozzáadása',
      autoFill: 'Automatikus kitöltés',
      placeholder: {
        selectContract: 'Válassz szerződést',
        invoiceNumber: 'Pl. SZ-2026-001'
      }
    }
  },
  nomination: {
    type: 'Nominálás típusa',
    types: {
      day_ahead: 'Előző napi',
      within_day: 'Napon belüli',
      long_term: 'Hosszú távú'
    },
    status: 'Státusz',
    statuses: {
      draft: 'Vázlat',
      submitted: 'Beküldött',
      confirmed: 'Visszaigazolt',
      rejected: 'Elutasított'
    },
    gasDay: 'Gáznap',
    quantityM3: 'Mennyiség (m³)',
    quantityKwh: 'Mennyiség (kWh)',
    submit: 'Beküldés',
    confirm: 'Visszaigazolás',
    noQuantity: 'Nincs mennyiség',
    fields: {
      contract: 'Szerződés (opcionális)',
      pod: 'POD (opcionális)',
      selectContract: 'Nincs szerződés kiválasztva',
      selectPod: 'Nincs POD kiválasztva',
      gasDay: 'Gáznap',
      type: 'Nominálás típusa',
      quantityM3: 'Mennyiség (m³)',
      quantityKwh: 'Mennyiség (kWh)',
      status: 'Státusz',
      notes: 'Megjegyzés'
    },
    errors: {
      gasDayRequired: 'Gáznap megadása kötelező',
      typeRequired: 'Nominálás típusa kötelező'
    }
  },
  messages: {
    loadError: 'Hiba a {{name}} betöltésekor',
    saveSuccess: '{{name}} sikeresen mentve',
    saveError: 'Hiba a {{name}} mentésekor',
    deleteSuccess: '{{name}} sikeresen törölve',
    deleteError: 'Hiba a {{name}} törlésekor',
    addSuccess: '{{name}} sikeresen hozzáadva',
    addError: 'Hiba a {{name}} hozzáadásakor',
    autoFillSuccess: 'Számlasorok automatikusan kitöltve',
    autoFillError: 'Hiba az automatikus kitöltés során',
    confirmDelete: 'Biztosan törlöd ezt a tételt?',
    confirmSubmit: 'Biztosan beküldöd ezt a nominálást?',
    confirm: 'Megerősítés',
    cancel: 'Mégse',
    ok: 'OK'
  },
  list: {
    title: '{{name}} lista',
    subtitle: '{{count}} tétel',
    refresh: 'Frissítés',
    noResults: 'Nincs megjeleníthető tétel.',
    search: {
      pods: 'Keresés POD ID, cím vagy ügyfél alapján...',
      contracts: 'Keresés szerződésszám, típus vagy státusz alapján...',
      readings: 'Keresés gáznap, POD ID vagy ügyfél alapján...',
      invoices: 'Keresés számlaszám, időszak vagy szerződés alapján...',
      nominations: 'Keresés gáznap, szerződés vagy státusz alapján...'
    }
  },
  dashboard: {
    gasCustomerSubtitle: 'Legalább egy gáz POD vagy szerződés',
    podsSubtitle: 'Földgáz POD törzsadatok és mérőhelyek',
    readingsSubtitle: 'Rögzített gáz mérőállások',
    nominationsSubtitle: 'Beküldött és visszaigazolt nominálások',
    activeTitle: 'Gáz modul aktív',
    activeDescription: 'A földgáz modul alap funkciói elkészültek: POD kezelés, szerződések, mérőállások, számlázás és nominálás.'
  },
  calendar: {
    title: 'Naptár',
    currentGasDay: 'Aktuális gáznap',
    currentGasYear: 'Aktuális gázév'
  },
  alerts: {
    expiringContracts: 'Hamarosan lejáró gáz szerződések',
    expiresToday: 'Ma lejár',
    daysRemaining: 'nap hátra',
    moreContracts: 'további szerződés'
  }
};
